import React from 'react';
import { 
  Smile, 
  Users, 
  TrendingUp, 
  TrendingDown,
  PartyPopper, 
  BookOpen, 
  Package, 
  Heart, 
  FlaskConical, 
  ClipboardList,
  BarChart,
  Briefcase,
  School,
  Building,
  Building2,
  Landmark,
  Target,
  Lightbulb,
  Search,
  CheckCircle,
  XCircle,
  AlertTriangle,
  MessageSquare,
  User,
  DollarSign,
  GraduationCap,
  Globe,
  Rocket,
  Star,
  Mail,
  Smartphone,
  Laptop,
  ShoppingCart,
  Gift,
  Trophy,
  Bell,
  Lock,
  Settings,
  LucideIcon 
} from 'lucide-react';

// 카테고리 아이콘 매핑
export const categoryIconMap: { [key: string]: LucideIcon } = {
  'smile': Smile,
  'users': Users,
  'chart': BarChart,
  'trending-up': TrendingUp,
  'trending-down': TrendingDown,
  'party': PartyPopper,
  'book': BookOpen,
  'package': Package,
  'health': Building,
  'science': FlaskConical,
  'clipboard': ClipboardList,
  'briefcase': Briefcase,
  'school': School,
  'building': Building2,
  'landmark': Landmark,
  'target': Target,
  'lightbulb': Lightbulb,
  'search': Search,
  'check': CheckCircle,
  'x': XCircle,
  'alert': AlertTriangle,
  'message': MessageSquare,
  'user': User,
  'dollar': DollarSign,
  'graduation': GraduationCap,
  'globe': Globe,
  'rocket': Rocket,
  'star': Star,
  'heart': Heart,
  'mail': Mail,
  'phone': Smartphone,
  'laptop': Laptop,
  'cart': ShoppingCart,
  'gift': Gift,
  'trophy': Trophy,
  'bell': Bell,
  'lock': Lock,
  'settings': Settings
};

// 이모지 아이콘 매핑 (기존 이모지와의 호환성을 위해)
export const emojiToIconMap: { [key: string]: LucideIcon } = {
  '😊': Smile,
  '👥': Users,
  '📈': TrendingUp,
  '🎉': PartyPopper,
  '📚': BookOpen,
  '📦': Package,
  '🏥': Heart,
  '🔬': FlaskConical,
  '📋': ClipboardList,
};

export const getCategoryIcon = (icon: string | null | undefined): LucideIcon => {
  if (!icon) return ClipboardList; // 기본 아이콘
  
  // 이미 이모지인 경우 해당하는 Lucide 아이콘 반환
  if (icon.length <= 2 && icon.match(/[\u{1F300}-\u{1F9FF}]/u)) {
    return emojiToIconMap[icon] || ClipboardList;
  }
  
  // 매핑된 아이콘 반환, 없으면 기본 아이콘
  return categoryIconMap[icon] || ClipboardList;
};

export const renderCategoryIcon = (icon: string | null | undefined, size: number = 20): React.ReactElement => {
  const IconComponent = getCategoryIcon(icon);
  return <IconComponent size={size} />;
};